import { ClipboardListIcon } from 'lucide-react'

import { Card, CardContent } from '@/components/card/card'

import { cn } from '@/lib/utils'

export interface CaseInfoCardProps {
  caseType?: string
  caseNumber?: string
  serviceCenter?: string
}

export const CaseInfoCard = ({ caseType, caseNumber, serviceCenter }: CaseInfoCardProps) => {
  return (
    <Card>
      <CardContent className={cn('p-6')}>
        <p className={cn('flex items-center gap-x-2', 'text-base font-semibold text-foreground')}>
          <ClipboardListIcon size={16} />
          Case Information
        </p>
        <div className={cn('flex flex-col items-center lg:flex-row lg:gap-x-2', 'mt-6')}>
          <Cell label="Case Type" value={caseType ?? '-'} />
          <Cell label="Case Number" value={caseNumber ?? '-'} />
          <Cell label="Service Center" value={serviceCenter ?? '-'} />
        </div>
      </CardContent>
    </Card>
  )
}

const Cell = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className={cn('flex flex-col gap-y-2', 'p-3 lg:p-4', 'text-center lg:text-left')}>
      <p className={cn('text-xs font-medium text-muted-foreground')}>{label}</p>
      <p className={cn('text-base font-medium text-text')}>{value}</p>
    </div>
  )
}
